module.exports = __webpack_public_path__ + "static/media/digital.1fa36e06.mp4";